import Vue from 'vue'
import pluginValue from './api'
const pluginName = '$defaultApi'

const plugin = {
  install(Vue) {
    window[pluginName] = pluginValue
    Vue.prototype[pluginName] = pluginValue
  },
}

Vue.use(plugin)

export default plugin

export const defaultApi = pluginValue
